import { render, staticRenderFns } from "./group.vue?vue&type=template&id=6b7fea6c&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7fea6c",
  null
  
)

export default component.exports